import { SceneLoader } from "@babylonjs/core/Loading/sceneLoader";
import { Vector3 } from "@babylonjs/core/Maths/math";

import "@babylonjs/loaders/glTF/2.0";


export default class Player {

    constructor(scene) {

        SceneLoader.ImportMeshAsync(null, "assets/models/", "kid.glb", scene)
            .then(
                (result) => {
                    result.meshes[0].receiveShadows = true;
                    result.meshes[0].position.x = -10;
                    result.meshes[0].position.y = -10;

                    console.log(` * * * The player mesh is now loaded.`);
                    console.log(result);


                    result.meshes[0].scaling = new Vector3(4, 4, 4);
                }
            );
    }
}

function onMeshLoaded(result) {
    console.log(` * * * The player mesh is now loaded.`);
}